import clsx from 'clsx';
import styles from './InfoBlock.module.scss';
import { isReceiptPdfOnly } from '../../../services/receiptUploadPolicy';

const buildConfirmData = (pdfOnly: boolean) =>
  `<ul><li>После оплаты вам необходимо будет загрузить ${
    pdfOnly ? 'PDF' : 'PDF или изображение'
  } чека из банковского приложения</li></ul>`;

const InfoBlock = ({
  data,
  confirm = false,
  merchant,
}: {
  data: string | null;
  confirm?: boolean;
  merchant?: string;
}) => {
  if (confirm) {
    return (
      <div
        className={clsx(styles.wrapper, confirm && styles.confirm)}
        dangerouslySetInnerHTML={{ __html: buildConfirmData(isReceiptPdfOnly(merchant)) }}
      />
    );
  }

  return data && data?.length > 1 ? (
    <div
      className={clsx(styles.wrapper, confirm && styles.confirm)}
      dangerouslySetInnerHTML={{ __html: data }}
    />
  ) : (
    <></>
  );
};

export default InfoBlock;
